import React, { useContext, useEffect, useRef, useState } from "react";
import { Bell } from "react-feather";
import { useNavigate } from "react-router-dom";
import { NotificationContext } from "../../../Components/Pages/Notifications/NotificationContext";

const Notificationbar = () => {
  const { notifications } = useContext(NotificationContext);
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);

  const displayedNotifications = notifications.slice(0, 5);

  const handleNotificationClick = (notificationId) => {
    navigate(`/page/notifications`);
    setIsDropdownOpen(false);
  };

  const handleCheckAllClick = () => {
    navigate(`/page/notifications`);
    setIsDropdownOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // Close on outside click
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <li className="nav-item position-relative" ref={dropdownRef}>
      <div
        className="notification-box d-flex align-items-center"
        onClick={toggleDropdown}
        style={{
          cursor: "pointer",
          padding: "8px 12px",
          borderRadius: "8px",
          transition: "background 0.2s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.background = "#f1f3f5")}
        onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
      >
        <Bell iconId="notification" size={20} className="text-primary" />
        {notifications.filter((n) => !n.isRead).length > 0 && (
          <span
            className="badge rounded-pill bg-danger position-absolute"
            style={{ top: "-2px", right: "-2px", fontSize: "0.7rem" }}
          >
            {notifications.filter((n) => !n.isRead).length}
          </span>
        )}
      </div>

      {isDropdownOpen && (
        <div
          className="dropdown-menu show p-0"
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            minWidth: "280px",
            maxWidth: "350px",
            borderRadius: "12px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
            border: "1px solid #e9ecef",
            background: "#fff",
            maxHeight: "400px",
            overflowY: "auto",
            zIndex: 1000,
          }}
        >
          <div
            className="bg-primary text-white p-3 rounded-top"
            style={{ fontSize: "1.1rem", fontWeight: "500" }}
          >
            Notifications
          </div>
          <ul className="list-group list-group-flush">
            {displayedNotifications.length > 0 ? (
              displayedNotifications.map((notification) => (
                <li
                  key={notification._id}
                  className="list-group-item p-3"
                  onClick={() => handleNotificationClick(notification._id)}
                  style={{
                    cursor: "pointer",
                    background: notification.isRead ? "#fff" : "#f8f9fa",
                    borderLeft: "4px solid #007bff",
                    transition: "background 0.2s",
                    margin: "2px",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "#e9ecef")}
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background = notification.isRead ? "#fff" : "#f8f9fa")
                  }
                >
                  <div className="d-flex flex-column">
                    <span
                      style={{
                        fontSize: "0.9rem",
                        fontWeight: notification.isRead ? "normal" : "500",
                        color: "#212529",
                      }}
                    >
                      {notification.title}
                    </span>
                    <small
                      style={{
                        color: "#6c757d",
                        fontSize: "0.75rem",
                        marginTop: "4px",
                      }}
                    >
                      {new Date(notification.createdAt).toLocaleString("en-US", {
                        dateStyle: "short",
                        timeStyle: "short",
                      })}
                    </small>
                  </div>
                </li>
              ))
            ) : (
              <li
                className="list-group-item p-3 text-center"
                style={{ color: "#6c757d", fontSize: "0.9rem" }}
              >
                No notifications available
              </li>
            )}
          </ul>
          <div className="p-3 border-top text-center">
            <button
              onClick={handleCheckAllClick}
              className="btn btn-primary btn-sm w-100"
              style={{
                borderRadius: "8px",
                padding: "8px 0",
                fontSize: "0.85rem",
                fontWeight: "500",
              }}
            >
              Check All
            </button>
          </div>
        </div>
      )}
    </li>
  );
};

export default Notificationbar;
